"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
require("./Bar.scss");
var Bar = /** @class */ (function (_super) {
    __extends(Bar, _super);
    function Bar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Bar.prototype.collapse = function (e) {
        e.preventDefault();
        if ($('#navbar-collapse-1').hasClass('collapse')) {
            $('#navbar-collapse-1').removeClass('collapse');
        }
        else {
            $('#navbar-collapse-1').addClass('collapse');
        }
    };
    Bar.prototype.updateDividers = function () {
        if ($(window).width() >= 768) {
            $('.vertical-divider').show();
        }
        else {
            $('.vertical-divider').hide();
        }
    };
    Bar.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.updateDividers);
    };
    Bar.prototype.render = function () {
        return (React.createElement("div", { role: 'navigation', className: 'navbar navbar-default' },
            React.createElement("div", { className: 'container-fluid' },
                React.createElement("div", { className: 'navbar-header' },
                    React.createElement("button", { type: 'button', className: 'navbar-toggle', "data-toggle": 'collapse', "data-target": '#navbar-collapse-1', "aria-expanded": 'false', onClick: this.collapse },
                        React.createElement("span", { className: 'icon-bar' }),
                        React.createElement("span", { className: 'icon-bar' }),
                        React.createElement("span", { className: 'icon-bar' })),
                    React.createElement(react_router_dom_1.Link, { className: 'navbar-brand', to: '/' },
                        React.createElement("span", { className: 'abb-logo-navbar' }),
                        React.createElement("span", { className: 'abb-logo-product-name' }, this.props.productName))),
                React.createElement("div", { className: 'collapse navbar-collapse', id: 'navbar-collapse-1' }, this.props.children))));
    };
    return Bar;
}(React.Component));
exports.Bar = Bar;
//# sourceMappingURL=Bar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Bar/Bar.js
// module id = 570
// module chunks = 1